export default __webpack_public_path__ + "static/7-aa5a9a91459782f35b5a394f70e6d0ae.jpg";